import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { unFormatCnpj } from "@/common/utils/unFormatters";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

interface UseCpfDetailsProps {
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

const useCpfDetails = ({ onSuccess, onError }: UseCpfDetailsProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ["cpfDetails"],
    mutationFn: async (cpf?: string) => {
      return privateAxios.get(`/external/vadu/cpf_details/${cpf ? unFormatCnpj(cpf) : ''}`);
    },
    onSuccess,
    onError,
  });
};

export default useCpfDetails;
